import { render, staticRenderFns } from "./MenuForm.vue?vue&type=template&id=8200db64&scoped=true"
import script from "./MenuForm.vue?vue&type=script&lang=js"
export * from "./MenuForm.vue?vue&type=script&lang=js"
import style0 from "./MenuForm.vue?vue&type=style&index=0&id=8200db64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8200db64",
  null
  
)

export default component.exports